import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=e8958064&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8958064')) {
      api.createRecord('e8958064', component.options)
    } else {
      api.reload('e8958064', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=e8958064&", function () {
      api.rerender('e8958064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/offershelp.vue"
export default component.exports